export const CLONE_TYPE = 'CLONE';
export const CLONE_DISPLAY_NAME = 'Clone';
